import { type ReactNode } from 'react';
import { graphql, type PreloadedQuery, usePreloadedQuery } from 'react-relay';

import type { AuthDataContextType } from '../utils/auth-context';
import { AuthDataContext } from '../utils/auth-context';

import type { authContextProviderQuery } from './__generated__/authContextProviderQuery.graphql';

export const AuthContextProvider = ({
	children,
	queryRef,
}: {
	children: ReactNode;
	queryRef: PreloadedQuery<authContextProviderQuery>;
}) => {
	const data = usePreloadedQuery<authContextProviderQuery>(
		graphql`
			query authContextProviderQuery {
				me @required(action: THROW) {
					user @required(action: THROW) {
						accountId @required(action: THROW)
						... on AtlassianAccountUser {
							picture
							name
							email
							locale
						}
					}
				}
			}
		`,
		queryRef,
	);

	const userData: AuthDataContextType = {
		user: {
			accountId: data.me.user.accountId,
			picture: data.me.user.picture ?? undefined,
			email: data.me.user.email ?? undefined,
			name: data.me.user.name ?? undefined,
			locale: data.me.user.locale ?? 'en-US',
		},
	};

	return <AuthDataContext.Provider value={userData}>{children}</AuthDataContext.Provider>;
};
